import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {Acesso} from 'src/app/core/acesso';
import {ControlContainer, NgForm} from '@angular/forms';
import {ToastService} from 'src/app/services/toast/toast.service';
import {AcaoExecutada} from "../../../core/acao-executada";
import {DataUtilService} from "../../../services/commons/data-util.service";
import {Funcionario} from "../../../core/funcionario";
import {FuncionarioService} from "../../../services/funcionario/funcionario.service";
import {FrequenciaAcao} from "../../../core/frequencias_acoes";
import {ComboFuncionario} from "../../../core/combo-funcionario";
import {ColaboradorAcao} from "../../../core/colaboradores_acoes";
import {MetaAcaoExecutada} from "../../../core/meta-acao-executada";
import {Acoes} from "../../../core/acoes";
import {MetaAcao} from "../../../core/meta-acao";

@Component({
    selector: 'formulario-acoes-executadas',
    templateUrl: './formulario-acoes-executadas.component.html',
    styleUrls: ['./formulario-acoes-executadas.component.css'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class FormularioAcoesExecutadasComponent implements OnInit {

    @Input() metasAcao: MetaAcao[];

    @Input() acoesExecutadas: AcaoExecutada[];
    @Input() acaoExecutada: AcaoExecutada;
    @Input() index: number;
    @Input() perfilAcesso: Acesso;

    idRandomico = Math.random();

    constructor(private drc: ChangeDetectorRef,
                private toastService: ToastService,
                private dataUtilService: DataUtilService,
                private funcionarioService: FuncionarioService) {
    }

    ngOnInit(): void {
    }

    ngAfterContentChecked(): void {
        this.drc.detectChanges();

    }

    deletar() {
        this.acoesExecutadas.splice(this.index, 1);
        this.toastService.showSucesso("Ação executada removida com sucesso.")
    }


    onMascaraDataInput(event) {
        return this.dataUtilService.onMascaraDataInput(event);
    }

    onValorChangeFuncionario(registro: ComboFuncionario) {
        if (registro && registro.id) {
            this.funcionarioService.getById(registro.id).subscribe((funcionario: Funcionario) => {
                this.acaoExecutada.funcionarioResponsavel = funcionario;
            })
        }
    }

    addFrequenciaAcao() {
        if (!this.acaoExecutada.frequencias) {
            this.acaoExecutada.frequencias = [];
        }

        const frequenciaAcao: FrequenciaAcao = new FrequenciaAcao();
        frequenciaAcao.id = undefined;
        this.acaoExecutada.frequencias.push(frequenciaAcao);
    }

    addColaboradorAcao() {
        if (!this.acaoExecutada.colaboradores) {
            this.acaoExecutada.colaboradores = [];
        }

        const colaboradorAcao: ColaboradorAcao = new ColaboradorAcao();
        colaboradorAcao.id = undefined;
        this.acaoExecutada.colaboradores.push(colaboradorAcao);
    }

    addMeta() {
        if (!this.acaoExecutada.metas) {
            this.acaoExecutada.metas = [];
        }

        const meta: MetaAcaoExecutada = new MetaAcaoExecutada();
        meta.id = undefined;
        this.acaoExecutada.metas.push(meta);
    }

}
